import { Row } from "@/components/container/Container";
import { TextTitleMedium2, TextTitleSmall2 } from "@/components/text/Texts";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useState } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";

const FAQ = [
	{
		title: 'How can I request rides for guests?',
		answer: 'The Xpress Concierge program empowers organizations to centrally request, oversee, and facilitate payment for rides for their customers, guests, and clients. Through a dedicated dashboard, rides can be effortlessly arranged for guest users, offering functionalities such as advanced scheduling, bulk booking, and item delivery requests. To commence, ensure the activation of the Xpress Concierge / Courtesy Rides program within Xpress for Business.',
	},
	{
		title: 'Is it necessary for guest users to have the Xpress app in order to avail Xpress rides?',
		answer: 'The Xpress Concierge program empowers organizations to centrally request, oversee, and facilitate payment for rides for their customers, guests, and clients. Through a dedicated dashboard, rides can be effortlessly arranged for guest users, offering functionalities such as advanced scheduling, bulk booking, and item delivery requests. To commence, ensure the activation of the Xpress Concierge / Courtesy Rides program within Xpress for Business.',
	},
	{
		title: 'Do guest users incur charges for Xpress Concierge trips?',
		answer: 'The Xpress Concierge program empowers organizations to centrally request, oversee, and facilitate payment for rides for their customers, guests, and clients. Through a dedicated dashboard, rides can be effortlessly arranged for guest users, offering functionalities such as advanced scheduling, bulk booking, and item delivery requests. To commence, ensure the activation of the Xpress Concierge / Courtesy Rides program within Xpress for Business.',
	},
	{
		title: 'What information is accessible on the Xpress Concierge Dashboard?',
		answer: 'The Xpress Concierge program empowers organizations to centrally request, oversee, and facilitate payment for rides for their customers, guests, and clients. Through a dedicated dashboard, rides can be effortlessly arranged for guest users, offering functionalities such as advanced scheduling, bulk booking, and item delivery requests. To commence, ensure the activation of the Xpress Concierge / Courtesy Rides program within Xpress for Business.',
	},
];

const ConciergeFaqAccordion = () => {
	const [activeAccordionIndex, setActiveAccordionIndex] = useState<number[]>([]);

	return (
		<Accordion
			className="-mr-6 -ml-6"
			activeIndex={activeAccordionIndex}
			onTabChange={(e) => setActiveAccordionIndex(e.index as number[])}
			multiple expandIcon collapseIcon
		>
			{FAQ.map((question, index) => (
				<AccordionTab key={`question-${index.toString()}`}
					header={(
						<Row className="justify-between">
							<TextTitleMedium2 text={question.title} className="text-onSurface" />
							{(activeAccordionIndex.includes(index)
								? <MdArrowDropUp size={24} color="black" />
								: <MdArrowDropDown size={24} color="black" />)}
						</Row>
					)}
				>
					<TextTitleSmall2 text={question.answer} className="text-onSurface" />
				</AccordionTab>
			))}
		</Accordion>
	);
};

export default ConciergeFaqAccordion;